// extracted by mini-css-extract-plugin
export var container = "reviews-section-module--container--uI-nv";
export var titleWrapper = "reviews-section-module--title-wrapper--ZPY6j";
export var grid = "reviews-section-module--grid--O2acZ";
export var quote = "reviews-section-module--quote--ZRtTe";
export var author = "reviews-section-module--author--dBt18";
export var gridItem = "reviews-section-module--grid-item--D7WsI";